/** Геттеры id и подписи для выборов: SearchSelect, FilterChip, ChipsField */
export const getId = (item: { id: string }): string => item.id;

export const getKey = (item: { key: string }): string => item.key;

export const getName = (item: { name: string }): string => item.name;

export const getDisplayName = (user: { displayName: string }): string => user.displayName;

/** «TIME: Учёт времени» — ключ и название очереди */
export const getQueueLabel = (queue: { key: string; name: string }): string =>
  `${queue.key}: ${queue.name}`;
